import React from 'react'
import styled from 'styled-components'
import Page from '../containers/Page'
import { H1, H2, ParagraphSica } from './../components/Typography'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${props => props?.width || 920}px;
  width: 100%;
  margin: 3rem auto;
  padding: 0 36px 90px;

  @media screen and (min-width: 768px) {
    padding: 0 36px 50px;
  }

  @media screen and (min-width: 992px) {
    padding: 0 0 120px;
    margin: 120px auto 0;
  }
`

const P = styled(ParagraphSica)`
  margin: 0 0 3rem;
`

const Link = styled.a`
  font-family: 'Sica', sans-serif;
  line-height: 1.5;
  text-decoration: none;
  color: #15405C;
`

const SubHeading = styled(H2)`
  margin: 2rem 0;
`

const InfoHeading = styled(H1)`
  margin: 0 auto 2rem;
`

const Information = () => (
  <Page title="Information">
    <Content>
      <InfoHeading>UNSPOILED, UNEXPLORED, UNBELIVEABLE</InfoHeading>
      <P>Remotely clustered in the North Atlantic Ocean, a rugged archipelago of eighteen mountainous islands erupts out of the ocean in imposing basalt cliffs.</P>
      <P>The Faroe Islands, sandwiched between Nordic neighbours Iceland and Norway, offer vast, untamed and spectacular landscapes that capture the imagination and are undeniably compelling.</P>
      <P>Travellers are overwhelmed by the grandiosity of the natural environment; the sheer sea cliffs, the unforgiving waves that break against the coastline and the lush green valleys nestling within the steep mountains.</P>
      <P>Days are lived as nature intended: without strife, without fuss, and always subject to capricious weather. Left in relative solitude since the first settlers arrived in the fourth century, the Faroese today exhibit a vibrant culture distinctly their own.</P>
      <P>To be Faroese is to be creative and diverse. Gifted chefs cook world-class cuisine. Artisans create masterpieces with wool and fabric. Architects design unique buildings. Artists and musicians explore their creative talents. Voices are raised in harmony. Jazz and heavy-metal infused folk music bridges the past and present, while the invasive drum beats of electropop and indie rock contribute to the eclectic strands of music genres. </P>
      <P>The Faroe Islands, translated directly as “sheep islands”, is a self-governing nation under the external sovereignty of the Kingdom of Denmark. This population of over just 50,000 people are endearingly hospitable and gentle in their manner. Love for their homeland is deep and honest. They are quiet natured, peaceful, and have a strong sense of community. Hospitality is innate - their doors are always open.</P>
      <P>Culture is the foundation of Faroese pride, with its independent language, flag and traditions. Within a generation, the prosperous fishing trade that accounts for approximately 20 percent of GDP has enabled an affluent lifestyle for the islanders. This is evident in the widespread use of technology and well-established infrastructure that connects the 18 islands by roads, bridges and subsea tunnels, making travel around the country effortless. This, together with first class telecommunications and high-speed internet, provides a solid foundation for maintaining the economic, social and cultural sustainability of communities all around the country.</P>
      <P>Although the islands exude the sense of a mysterious land far away, they can be reached by air in only two hours from continental Europe.</P>
      
      <SubHeading>QUICK FACTS </SubHeading>
      <P>Location: In the middle of the Gulf Stream in the North Atlantic at 62º00’N and 06º47’W, halfway between Scotland and Iceland</P>
      <P>Total land area: 1,399km2 (540 square miles) <br />
      Total marine area: 247,000km2 (105,792 square miles) <br />
      Area: Faroese archipelago, 113km (70 miles) long and 75km (47 miles) wide. Total coastline of 1,100km (687 miles). No point in the Faroe Islands is further than 5km (3 miles) from the sea.
      <br />
      Islands: 18 volcanic islands separated by narrow sounds and fjords arranged roughly in the form of an arrowhead. All but one are inhabited.<br />
      Heights: Highest peak 880m (2,887ft); average height above sea level 300m (980ft) <br />
      Climate: Average 3º-11ºC, winter-summer <br />
      Population: 53,022 (January 2021) <br />
      Status: Self-governing region within Kingdom of Denmark <br />
      
      Language: Faroese. Danish has equal status in all official affairs <br />
      
      Main industries: Fishing and aquaculture, shipping and offshore services and tourism <br />
      
      Currency: Faroese króna (DKK) <br />
      
      Time: GMT (winter); GMT+1 (summer) <br />
      </P>
      
      <SubHeading>Getting to the Faroe Islands:</SubHeading>
      <P>Even though the Faroe Islands is remotely located in the North Atlantic Ocean, reaching the islands is much easier than most people think. The Faroe Islands is only a short flight from mainland Europe!</P>
      
      <SubHeading>Flying to the Faroe Islands</SubHeading>
      <P>You can fly non-stop to the Faroe Islands from a variety of destinations, such as Copenhagen (Denmark), Paris (France), Reykjavik (Iceland), Edinburgh (Scotland), and Bergen (Norway). Please note that many of these routes are currently suspended because of the Covid-19 pandemic, but will most likely return later this year.
      <br />
      Two airlines fly to the Faroe Islands. These are Atlantic Airways and Scandinavian Airlines.<br />
      <br />
      Flights from Reykjavik, Edinburgh and Bergen to the Faroe Islands with Atlantic Airways are only one hour long, and flights from Copenhagen with either Atlantic Airways or Scandinavian Airlines last only two hours. Direct flights from Paris to the Faroe Islands with Atlantic Airways last 2 hours and 45 minutes.
      </P>

      <SubHeading>Sailing to the Faroe Islands</SubHeading>
      <P>The Faroe Islands can also be reached by ferry from Iceland and Denmark. Slow travel at its best! This service is operated by Faroese company, Smyril Line.</P>
    
      <SubHeading>Bookings and Inquiries</SubHeading>
      <P>Please contact GreenGate Incoming: (vit mugu líka blíva samd um hvussu tey kontakta okkum, um kemur ein kontakt formularur á heimasíðuna. Umframt mail og telefon) </P>

      <SubHeading>Accommodation</SubHeading>
      <P>We have preliminary hotel reservations at Hilton Garden Inn Faroe Islands, Tórshavn. Please book accommodation on the online registration form. In order to obtain the specified prices, your reservation must be made through GreenGate Incoming/Petur Larsen.</P>

      <SubHeading>About Hilton Garden Inn Faroe Islands:</SubHeading>
      <P>Rest well at our hotel in Tórshavn!<br />
        Just five minutes from the beautiful Svartafoss Waterfall, Nordic House, and the National Museum of the Faroe Islands.
      </P>
      <P>Hilton Garden Inn Faroe Islands is the only international hotel in the Faroe Islands. A unique, exquisitely beautiful and modern hotel with spectacular panoramic views in serene surroundings.
      </P>
      <P>The Hilton Garden Inn Faroe Islands is the epitome of Nordic luxury and comfort in the Faroe Islands. Enjoy the world-renowned Hilton brighthearted hospitality, quality and services in one of the world’s smallest capitals, Tórshavn.
      </P>

      <SubHeading>Getting around on the Faroe Islands:</SubHeading>
      <P>Petur Larsen offers complementary transfer from the airport to your hotel (return) along with transfer to Fuglafjørður on the 29th of October. </P>

      <P>But: <br />
      One of the best ways to experience the Faroe Islands is by car, as it gives you the freedom to explore at your own pace.
      The Faroe Islands have 900 kilometers of roads, 450 kilometers are highway and 450 kilometers are country roads. Most are two-lane and paved.
      </P>
      <P>17 of the 18 islands are connected by bridges, dams, ferry routes, or helicopter service. After the establishment of three sub sea tunnels, it became easy to travel from one end of the country to the other.</P>
      <P>Faroese roads have route numbers. The main highway with two lanes has a two digit number, but the more local roads associated with the villages have three digits.</P>
      <P>When you drive in the Faroe Islands, you must pay particular attention to the sheep when they are on the roads. One should slow down when sheep are at the side of the road.</P>
      <P>Not all tunnels are equipped with lighting, so it is required to drive with your lights turned on in the Faroe Islands.</P>

      <P>
      <b>Please contact GreenGate Incoming and we will give you an offer on a rental car.</b><br /> 
      <Link href='https://www.greengate.fo/' target='_blank' rel='noopener noreferrer'>https://www.greengate.fo/</Link><br />
      <Link href='mailto:info@greengate.fo'>Mail: info@greengate.fo</Link><br />
      <Link href='tel:+298 350 520'>Phone: +298 350 520</Link>
      </P>
    </Content>
  </Page>
)


export default Information
